// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__byGZQ","left":"StickyBox_left__3T_8L","right":"StickyBox_right__Xs_94"};